import { useGetVerifiedUsersBirthdayQuery } from '../../features/apis/authApi';
import { holidaysList } from '../../holidays';
import EmployeeAvatar from '../Common/EmployeeAvatar';

function UpcomingEvents() {
  const { data: birthdayData } = useGetVerifiedUsersBirthdayQuery();
  const birthdayArr = birthdayData?.employees || [];

  const formatDate = (dateString: string | Date) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-IN', {
      weekday: 'short',
      day: '2-digit',
      month: 'short',
    });
  };
  const combinedEvents = [
    ...birthdayArr?.map((user: any) => ({
      id: user.id,
      name: user.name,
      avatar: user.avatar,
      date: user.dob,
      leaveType: 'Birthday',
    })),
    ...holidaysList.map((holiday, index) => ({
      id: `holiday-${index}`,
      name: holiday.info,
      avatar: null,
      date: holiday.date,
      leaveType:
        holiday.type === 'standard' ? 'Standard(holiday)' : 'Optional(holiday)',
    })),
  ];
  const filteredEvents = combinedEvents.filter((event) => {
    return event.date && !isNaN(Date.parse(event.date));
  });

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const upcomingSorted = filteredEvents
    .map((event) => {
      const eventDate = new Date(event.date);
      let normalizedDate = new Date(eventDate);

      if (event.leaveType === 'Birthday') {
        normalizedDate.setFullYear(today.getFullYear());
        if (normalizedDate < today) {
          normalizedDate.setFullYear(today.getFullYear() + 1);
        }
      }

      return { ...event, normalizedDate };
    })
    .filter(
      (event) =>
        !isNaN(event.normalizedDate.getTime()) && event.normalizedDate >= today
    )
    .sort((a, b) => a.normalizedDate.getTime() - b.normalizedDate.getTime());

  return (
    <div className="bg-white mt-6 md:mt-11 p-4 rounded-md h-[84%] flex flex-col font-poppins font-light">
      <h1 className="text-base font-semibold  sticky top-0 font-inter ">
        Upcoming Events
      </h1>
      <div className=" my-3 h-[0.5px] bg-[#D4D4D4]" />{' '}
      <div className="overflow-y-auto h-[260px] bg-white hide-scrollbar">
        {upcomingSorted.length === 0 ? (
          <p className="text-sm text-gray-400 text-center">
            No upcoming events
          </p>
        ) : (
          upcomingSorted.map((event) => (
            <div
              key={event.id}
              className="grid grid-cols-5 py-2 px-3 border-b-[0.5px] font-inter border-[#D4D4D4] items-center"
            >
              <div className="flex items-center col-span-3">
                <EmployeeAvatar
                  name={event.name}
                  avatar={event.avatar}
                  size="sm"
                  className="mr-3"
                />
                <div className="truncate">
                  <div className="font-semibold text-[10px] capitalize truncate">
                    {event.name.split(' ').slice(0, 2).join(' ')}
                  </div>
                  <div className="text-[10px] text-[#6E3EF5]">
                    {formatDate(event.date)}
                  </div>
                </div>
              </div>
              <div className="text-[8px] text-left col-span-2 flex items-center">
                <span
                  className={`px-2 py-1 rounded-sm ${
                    event.leaveType === 'Birthday'
                      ? 'bg-[#F0EAD1]'
                      : event.leaveType === 'Standard(holiday)'
                      ? 'bg-[#CBF6D5]'
                      : 'bg-[#DCEAF6]'
                  }`}
                >
                  {event.leaveType}
                </span>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default UpcomingEvents;
